/* eslint-disable no-underscore-dangle */
import lod_ from "lodash";
import { Dialog, DialogContent, Fab, Fade, Icon } from "@mui/material";
import { useEffect, useState } from "react";
import FormAction from "redux-react/actions/formAction";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "components/Basics/MDBox";
import { createDictionarySkeleton } from "helpers/form";
import { LittleForm } from "components/Custom/LittleForm";
import RenderAssetDisplay from "./RenderFileDisplay";
import RenderMailDisplay from "./RenderMailDisplay";
import Header from "./Header";
import MDTypography from "components/Basics/MDTypography";
import { t } from "i18next";
import { display } from "redux-react/reducers/snackBarReducer";
import { selectUser } from "redux-react/reducers/userReducers";
import { getObjectDifference } from "helpers/utilities";

const AnalyseDocumentDisplay = ({
	open,
	onClose,
	action,
	values,
	dictionary,
	resource,
	updateResource,
	insertResourceEvent,
	performFrontAction,
	...rest
}) => {
	const user = useSelector(selectUser);
	const [canSaveChanges, setCanSaveChanges] = useState(false);
	const [displayMode, setDisplayMode] = useState("file");

	const dispatch = useDispatch();
	const analyseDictionary = (dictionary || {})[resource?.format?.dictionary]?.items?.context ?? {};

	const [item, setItem] = useState(null);

	const [analyseForm, setAnalyseForm] = useState(null);
	const [analyseFormCopy, setAnalyseFormCopy] = useState(null);

	/* Save updated settings */
	const handleSave = () => {
		const onSuccess = res => {
			dispatch(
				display({
					message: t("SETTINGS.SEETINGSADMIN.CALL.successUpdate"),
					type: "success"
				})
			);
		};

		const differences = getObjectDifference(analyseFormCopy, analyseForm, "context");

		updateResource(resource?.code, item._id, { context: analyseForm }, onSuccess);
		setAnalyseFormCopy(lod_.cloneDeep(analyseForm));
		// Update item
		const newItem = { ...item, context: analyseForm };
		setItem(newItem);
		// Send event
		insertResourceEvent(resource?.code, item._id, {
			action: "resource.SAVE",
			actor: user.userID,
			payload: { delta: differences }
		});
	};

	const fetchItem = async id => {
		dispatch(
			FormAction.getItemsFromCollection(
				resource.storage.collection,
				{
					query: {
						_id: id
					}
				},
				res => {
					const fetchedItem = res.items[0] ?? {};
					const analyseItem = fetchedItem?.context;
					setItem(fetchedItem);
					const buildedForm = createDictionarySkeleton(analyseDictionary, analyseItem);
					setAnalyseForm(buildedForm);
					setAnalyseFormCopy(lod_.cloneDeep(buildedForm));
				}
			)
		);
	};

	const handleChangeState = newState => {
		const newItem = { ...item };
		newItem.state = newState;
		setItem(newItem);

		// Update resource
		updateResource(resource?.code, item._id, { state: newState }, () => {});
	};

	const updateItem = update => {
		const newItem = { ...item, ...update };
		setItem(newItem);
	};

	const isDisabled = () => {
		if (item?.state !== "ongoing") {
			return true;
		}

		if (item?.agent !== user.userID) {
			return true;
		}

		return false;
	};

	useEffect(() => {
		if (!lod_.isEqual(analyseForm, analyseFormCopy)) {
			setCanSaveChanges(true);
		} else {
			setCanSaveChanges(false);
		}
	}, [analyseForm, analyseFormCopy]);

	useEffect(() => {
		if (open && !lod_.isNil(values) && !lod_.isNil(values?._id) && !lod_.isNil(resource)) {
			fetchItem(values._id);
			setDisplayMode("file");
		} else {
			setItem(null);
			setAnalyseForm(null);
			setDisplayMode("file");
		}
	}, [open]);

	if (lod_.isNil(analyseForm) || lod_.isNil(item) || lod_.isNil(resource)) {
		return null;
	}

	return (
		<Dialog open={open} fullScreen>
			<DialogContent
				sx={{
					p: 0,
					m: 0,
					display: "flex",
					flexDirection: "row"
				}}
			>
				{/* Display pannel */}
				<MDBox flex="3" bgColor="light" display="flex">
					{displayMode === "file" ? (
						<RenderAssetDisplay document={item.document ?? {}} />
					) : (
						<RenderMailDisplay mail={item.mail ?? {}} />
					)}
				</MDBox>
				{/* Form pannel */}
				<MDBox
					flex="3"
					sx={{
						display: "flex",
						alignItems: "start",
						overflowY: "auto",
						minWidth: 0,
						flexDirection: "column"
					}}
				>
					<Header
						item={item}
						onClose={onClose}
						onChangeState={handleChangeState}
						performFrontAction={performFrontAction}
						updateItem={updateItem}
						actions={resource.events ?? []}
						resource={resource}
						displayMode={displayMode}
						onModeChange={setDisplayMode}
					/>
					<MDBox
						sx={{
							width: "100%",
							maxWidth: "100%",
							minWidth: 0,
							overflowY: "auto",
							pr: 1,
							pl: 1,
							pb: 10
						}}
					>
						<LittleForm
							disabled={isDisabled()}
							collapseActions
							object={analyseDictionary.items ?? {}}
							metadatasSkeleton={analyseForm}
							listAPIs={[]}
							handleChange={(path, value) => {
								const newForm = { ...analyseForm };
								lod_.set(newForm, path, value);
								setAnalyseForm(newForm);
							}}
						/>
					</MDBox>
				</MDBox>
				{/* Actions -> do not display for now */}
				{/* <MDBox
					flex="1"
					bgColor="light"
					display="flex"
					flexDirection="column"
					justifyContent="space-between"
					p={2}
				></MDBox> */}

				<Fade in={canSaveChanges}>
					<div
						style={{
							position: "fixed",
							bottom: 20,
							right: 20,
							zIndex: 1000
						}}
					>
						<Fab variant="extended" color="info" onClick={handleSave} size="small">
							<MDTypography variant="h6" color="light" fontSize="small">
								{t("SETTINGS.RULES.detectedModifications")}
							</MDTypography>
							<MDBox
								bgColor="light"
								p={0.5}
								borderRadius="lg"
								display="flex"
								alignItems="center"
								ml={1}
							>
								<Icon sx={{ mr: 0.5 }}>save</Icon>
								<MDTypography variant="button" color="dark" fontSize="small" fontWeight="bold">
									{t("SETTINGS.save")}
								</MDTypography>
							</MDBox>
						</Fab>
					</div>
				</Fade>
			</DialogContent>
		</Dialog>
	);
};

export default AnalyseDocumentDisplay;
